import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useGetGuidelineQuery } from "../redux/Apis/Guideline";

const useCommunityController = (
  externalUserId = null,
  selectedFilter = "",
  search = "",
) => {
  const location = useLocation();
  const lang = useSelector((state) => state.language.lang);
  const { id } = useParams();
  const { user } = useSelector((state) => state.authSlice);

  const paramUserId = id;
  const stateUserId = location.state?.userId;

  const userId = externalUserId || stateUserId || paramUserId || null;

  const [discussions, setDiscussions] = useState([]);

  const { data, isLoading, isFetching, isSuccess, refetch } =
    useGetGuidelineQuery(
      {
        params: {
          lang,
          ...(userId ? { user: userId } : {}),
          ...(selectedFilter
            ? {
                user: user?._id,
                type: selectedFilter,
              }
            : {}),
          ...(search ? { search } : {}),
        },
      },
      {
        refetchOnMountOrArgChange: true,
      },
    );

  useEffect(() => {
    if (isSuccess && data?.data) {
      setDiscussions(data.data);
    }
  }, [isSuccess, data]);

  return {
    values: {
      user,
      data: discussions,
      isLoading: isLoading || isFetching,
    },
    functions: {
      setDiscussions,
    },
    refetch,
  };
};

export default useCommunityController;
